import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiResponse } from '../classes/api-response';
import { environment } from '../../environments/environment';
import { map } from 'rxjs/operators';
import { BoxLocation } from '../model/box-location';
import { HttpClient } from '@angular/common/http';
import { Constants } from "../utils/constants";
import { UtilsService } from "./utils.service";

@Injectable({
  providedIn: 'root'
})
export class LocationsService {

  private readonly entities = Constants.entities;
  private readonly crtlPathFt = this.entities.locations;
  private readonly ctrlFullPath = `${environment.apiUrl}/${this.crtlPathFt}`;

  constructor(private http: HttpClient) {
  }

  public getAllLocations(statuses?: string[]): Observable<BoxLocation[]> {
    const params = UtilsService.buildUrl(statuses);
    return this.http
      .get<ApiResponse>(`${this.ctrlFullPath}`, { params })
      .pipe(map(value => value.data as BoxLocation[]));
  }
/*
  public getLocation(id?: number, statuses?: string[]): Observable<Location> {
    const params = UtilsService.buildUrl(statuses);
    return this.http
      .get<ApiResponse>(`${this.ctrlFullPath}/${id}`, { params })
      .pipe(map(value => value.data as Location));
  }

  public createLocation(location: Location): Observable<Location> {
    return this.http
      .post<ApiResponse>(`${this.ctrlFullPath}`, location)
      .pipe(map(value => value.data as Location));
  }

  public updateLocation(location: Location): Observable<void> {
    return this.http
      .patch<ApiResponse>(`${this.ctrlFullPath}/${location.id}`, location)
      .pipe(map(() => { }));
  }

  public deleteLocation(id: number): Observable<void> {
    return this.http
      .delete<ApiResponse>(`${this.ctrlFullPath}/${id}`)
      .pipe(map(() => { }));
  }

  public associateLocation(boxId?: number, location?: Location): Observable<void> {
    return this.http
      .put<ApiResponse>(`${environment.apiUrl}/${this.entities.boxes}/${boxId}/${this.entities.locations}`, location)
      .pipe(map(() => { }));
  }

  public deleteLocationAssociation(boxId?: number): Observable<void> {
    return this.http
      .delete<ApiResponse>(`${environment.apiUrl}/${this.entities.boxes}/${boxId}/${this.entities.locations}`)
      .pipe(map(() => { }));
  }
*/
}
